<div class="multi-select-dropdown form-control">
  <button
    type="button"
    class="multi-select-dropdown__trigger"
    [attr.id]="triggerId || null"
    [attr.aria-expanded]="open"
    aria-haspopup="listbox"
    [attr.aria-labelledby]="ariaLabelledBy || null"
    (click)="onTriggerClick($event)"
  >
    <span class="multi-select-dropdown__trigger-text">{{ triggerText }}</span>
    <span class="multi-select-dropdown__chevron" aria-hidden="true"></span>
  </button>
  @if (open) {
    <div
      class="multi-select-dropdown__panel"
      role="listbox"
      aria-multiselectable="true"
      (click)="$event.stopPropagation()"
    >
      @for (item of items; track item.id) {
        <div
          class="multi-select-dropdown__row"
          role="option"
          [attr.aria-selected]="isSelected(item.id)"
        >
          <span
            class="multi-select-dropdown__label"
            (click)="onToggleItem(item.id)"
            >{{ item.label }}</span
          >
          <mat-checkbox
            class="multi-select-dropdown__checkbox"
            [checked]="isSelected(item.id)"
            (click)="$event.stopPropagation(); onToggleItem(item.id)"
          ></mat-checkbox>
        </div>
      }
    </div>
  }
</div>
